import React, { useState } from 'react'
import { connect } from 'react-redux'
import './Chart.scss'
import { Chart as PrimeReactChart} from 'primereact/chart';

export interface ChartProps {
    type: string
    data: any
    options?: any
}

const Chart = (props: ChartProps) => {
    const { type, data, options} = props
    const componentClass = 'smart-modals-chart'

    return (
        <div className={componentClass}>
            <PrimeReactChart type={type} data={data} options={options}/>
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Chart)
